import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Title,
  Text,
  PasswordInput,
  Button,
  Stack,
  Center,
} from '@mantine/core';
import { IconLock, IconCheck, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import api from '../api/axiosConfig';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // URL'den ?token= kısmını alıyoruz
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      notifications.show({
        title: 'Geçersiz İstek',
        message: 'Şifre sıfırlama token\'ı bulunamadı. Lütfen maildeki linke tekrar tıklayın.',
        color: 'red',
        icon: <IconX size={16} />,
      });
      return;
    }

    if (password.length < 6) {
      notifications.show({
        title: 'Uyarı',
        message: 'Şifreniz en az 6 karakter olmalıdır.',
        color: 'yellow',
      });
      return;
    }

    if (password !== confirmPassword) {
      notifications.show({
        title: 'Uyarı',
        message: 'Şifreler eşleşmiyor.',
        color: 'yellow',
      });
      return;
    }

    setLoading(true);
    try {
      // Backend'e token ve yeni şifreyi gönderiyoruz
      // NOT: Bu endpoint auth gerektirmeyen public bir endpoint olmalı
      await api.post('/auth/reset-password-confirm', {
        token: token,
        new_password: password,
      });

      notifications.show({
        title: 'Başarılı!',
        message: 'Şifreniz başarıyla güncellendi. Şimdi giriş yapabilirsiniz.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });

      // Başarılı olunca login sayfasına yönlendir
      navigate('/login');
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Şifre sıfırlama işlemi başarısız oldu. Linkin süresi dolmuş olabilir.';
      notifications.show({
        title: 'Hata',
        message: errorMsg,
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Center mb="lg">
        <IconLock size={48} color="#228be6" />
      </Center>
      <Title ta="center" order={2}>
        Yeni Şifre Belirleme
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt={5} mb={30}>
        Lütfen hesabınız için yeni bir şifre giriniz.
      </Text>

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        {!token ? (
          <Text c="red" ta="center" fw={500}>
            Geçersiz veya eksik sıfırlama bağlantısı!
          </Text>
        ) : (
          <form onSubmit={handleSubmit}>
            <Stack>
              <PasswordInput
                label="Yeni Şifre"
                placeholder="Yeni şifreniz"
                required
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              <PasswordInput
                label="Yeni Şifre (Tekrar)"
                placeholder="Yeni şifrenizi doğrulayın"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.currentTarget.value)}
              />
              <Button type="submit" fullWidth mt="xl" loading={loading} color="blue">
                Şifreyi Güncelle
              </Button>
            </Stack>
          </form>
        )}
      </Paper>
    </Container>
  );
}